<template>
  <div class="types-of-practice">
    <div
      v-for="(item, index) in practiceList"
      :key="index"
      class="practice-item"
      @click="choosePractice(item)"
    >
      <div class="practice-item-text">{{ item.text }}</div>

      <img src="@/assets/images/free-practice/yellow__next_arrow.png" class="next-arrow" />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      practiceList: [
        {
          text: this.$t('word_flashcards'),
          key: 'FLASHCARDS',
        },
        {
          text: this.$t('word_practice'),
          key: 'EXERCISE',
        },
        {
          text: this.$t('analyse_text'),
          key: 'ANALYSE',
        },
      ],
    }
  },
  methods: {
    choosePractice(item) {
      this.$emit('choosePractice', item.key)
    },
  },
}
</script>
<style lang="scss" scoped>
// 练习方式选择：借用新版原型的卡片语言（白卡 + 1px 米灰边 + 14px 圆角，悬停上浮、描边转橙）
.types-of-practice {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  padding: 24px 23px 4px;
  .practice-item {
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    gap: 22px;
    min-height: 148px;
    padding: 20px 20px 18px;
    border: 1px solid #e5e1d8;
    border-radius: 14px;
    background: #fff;
    box-shadow: 0 4px 12px rgba(44, 47, 70, 0.035);
    cursor: pointer;
    transition: transform 0.2s cubic-bezier(0.2, 0.8, 0.2, 1), border-color 0.2s, box-shadow 0.2s;
    .practice-item-text {
      color: #2c2f46;
      font-size: 17px;
      font-weight: 650;
      line-height: 1.3;
      letter-spacing: -0.01em;
      word-break: break-word;
    }
    .next-arrow {
      display: block;
      box-sizing: border-box;
      width: 34px;
      height: 34px;
      padding: 7px;
      border-radius: 50%;
      background: #fff1df;
      transition: background 0.2s, transform 0.2s;
    }
    &:hover {
      transform: translateY(-3px);
      border-color: #e8c79f;
      box-shadow: 0 12px 24px rgba(44, 47, 70, 0.09);
      .next-arrow {
        background: #ffe3bd;
        transform: translateX(3px);
      }
    }
    &:focus-visible {
      outline: 3px solid rgba(250, 174, 86, 0.43);
      outline-offset: 2px;
    }
  }

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 10px;
    padding: 16px 16px 0;
    .practice-item {
      flex-direction: row;
      align-items: center;
      min-height: 0;
      padding: 16px 18px;
      .practice-item-text {
        font-size: 16px;
      }
    }
  }
}
</style>
